import React from "react";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";

import { AuthActions } from "app/redux/actions";
import { LoadingSelectors } from "app/redux/reducers";
import { getAuthData } from "app/services/auth";
import AdvancedButton from "components/shared/AdvancedButton/AdvancedButton";

class LoginWithRecaptcha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: false,
    };
  }

  userAuth = async e => {
    e.preventDefault();
    const { googleReCaptchaProps } = this.props;
    let recaptcha = await googleReCaptchaProps.executeRecaptcha("homepage");

    this.props.getAuthenticateUrl({ recaptcha }, ({ url }) => {
      window.open(url, "_self");
    });
  };

  componentDidMount() {
    const isAuthenticated = getAuthData();
    if (isAuthenticated) {
      window.location.href = I18n.t("routes.partner.url");
    }
  }

  render() {
    const { loading } = this.props;
    const isAuthenticated = getAuthData();

    if (isAuthenticated) {
      return null;
    }

    return (
      <>
        <div className="app-login">
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-xl-6 col-sm-12 order-xl-2">
                <div className="row align-items-center">
                  <div className="col no-pd">
                    <div className="app-login__banner">
                      <img
                        src="/assets/svg/overlay.svg"
                        className="img-fluid app-login__banner__content__overlay"
                        alt="overlay"
                      />
                      <div className="app-login__banner__content">
                        <div className="row justify-content-center">
                          <div className="col-lg-8 col-md-12 m-3">
                            <img
                              src="/assets/svg/cpfl-logo.svg"
                              className="img-fluid app-login__banner__content__logo"
                              alt="cpfl-logo"
                            />
                            <h1 className="app-login__banner__content__title mt-5">
                              {I18n.t("routes.login.content.title")}
                            </h1>
                            <h2 className="app-login__banner__content__sub-title">
                              {I18n.t("routes.login.content.subtitle")}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-sm-12 order-xl-1">
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-12 m-3">
                    <div className="position-relative">
                      <div className="app-login__block__header">
                        <div className="row">
                          <div className="col-12">
                            <h1 className="app-login__block__header__hello">
                              Backoffice - CPFL Total
                            </h1>
                            <p className="app-login__block__header__greetings">
                              Clique abaixo para acessar o sistema.
                            </p>
                          </div>
                        </div>
                      </div>
                      <form onSubmit={e => this.userAuth(e)}>
                        <div className="row">
                          <div className="col-12">
                            <div className="app-login__block__button">
                              <AdvancedButton
                                center
                                submit
                                text={I18n.t(
                                  "routes.login.content.loginButton"
                                )}
                                disabled={loading && loading > 0}
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const Login = withGoogleReCaptcha(LoginWithRecaptcha);

const mapStateToProps = state => ({
  loading: LoadingSelectors.getLoading(state),
});

const mapDispatchToProps = dispatch => ({
  getAuthenticateUrl: (recaptcha, callback) =>
    dispatch(AuthActions.getAuthenticateUrl(recaptcha, callback)),
  getMe: () => dispatch(AuthActions.getMe()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
